'use es6';

import http from 'hub-http/clients/apiClient';
import { fromJS } from 'immutable';
const DASHBOARD_URL = 'dashboard/v2/dashboard';
export const getDashboardWidgetCounts = () => http.get(`${DASHBOARD_URL}/widget-counts`).then(fromJS);